import { FC, PropsWithChildren, ReactNode } from 'react';

import clsx from 'clsx';

import css from './PageTitle.module.css';

import { WithClassName } from 'v2/types';

interface PageTitleProps extends WithClassName {
  action?: ReactNode;
}

export const PageTitle: FC<PropsWithChildren<PageTitleProps>> = ({ className, action, children }) => (
  <div className={css.pageTitleContainer}>
    <h2 className={clsx(css.pageTitle, className)}>{children}</h2>

    {action}
  </div>
);
